export const getVideoIframe = (url) => {
    const regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return match[7].length === 11
        ? `https://www.youtube.com/embed/${match[7]}`
        : false;
};
